import Immutable from 'immutable';

const initialState = Immutable.Map();

function guestSearchReset(state, payload) {
  state.setIn(['search', 'picked'], null);
  state.setIn(['search', 'results'], null);
  state.setIn(['search', 'loading'], false);
  state.setIn(['search', 'completed'], false);
  state.setIn(['search', 'failed'], false);
}

function guestPicked(state, payload) {
  state.setIn(['search', 'picked'], payload);
  state.setIn(['search', 'results'], Immutable.fromJS([payload]));
}

function guestSearchStarted(state, payload) {
  state.setIn(['search', 'loading'], true);
  state.setIn(['search', 'completed'], false);
  state.setIn(['search', 'failed'], false);
}

function guestSearchCompleted(state, payload) {
  state.setIn(['search', 'results'], payload);
  state.setIn(['search', 'loading'], false);
  state.setIn(['search', 'completed'], true);
  state.setIn(['search', 'failed'], false);
}

function guestSearchFailed(state, payload) {
  state.setIn(['search', 'loading'], false);
  state.setIn(['search', 'completed'], true);
  state.setIn(['search', 'failed'], true);
}

export default function reducer(state = initialState, { type, payload }) {
  return state.withMutations((state) => {
    return (
      {
        GUEST_PICKED: guestPicked,
        GUEST_SEARCH_STARTED: guestSearchStarted,
        GUEST_SEARCH_COMPLETED: guestSearchCompleted,
        GUEST_SEARCH_FAILED: guestSearchFailed,
        GUEST_SEARCH_RESET: guestSearchReset,
      }[type] || (() => state)
    )(state, payload);
  });
}
